import { useEffect } from 'react';
import { find } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicleById } from '../store/actions/vehicles';

export const useVehicleLoader = vehicleId => {
  const dispatch = useDispatch();
  const vehicles = useSelector(state => state.vehicles.list);

  useEffect(() => {
    if (vehicleId) {
      const exists = find(vehicles, { id: vehicleId });
      if (!exists) {
        dispatch(fetchVehicleById(vehicleId));
      }
    }
  }, [dispatch, vehicleId, vehicles]);

  const vehicle = vehicleId ? find(vehicles, { id: vehicleId }) || null : null;

  return { vehicle };
};
